import React from "react";
import ReactMarkdown from "react-markdown";
import { call, put, takeEvery, select } from "redux-saga/effects";
import { Body } from "@ddm-design-system/typography";
import { IJCoreService } from "../services/jcore";
import { IAppContext } from "../services";
import { IRequestBeers, IEditBeer, REQUEST_BEERS, EDIT_BEER } from "../store/beers/types";
import { getCurrentContent } from "../store/content/selectors";
import { getBeverage, getBeverageName } from "../store/beers/reducer";
import { requestBeersSuccess, requestBeersError } from "../store/beers/actions";
import {
  setPressureChamberBeverage,
  setPressureChamberBeverageError
} from "../store/installation/actions";

export function* requestBeers(jCoreService: IJCoreService, action: IRequestBeers) {
  try {
    const result: any = yield call(
      [jCoreService, jCoreService.getBeers],
      action.payload.locationIds
    );

    yield put(requestBeersSuccess(result.data));
  } catch (error) {
    yield put(requestBeersError(error));
  }
}

export function* editBeer(context: IAppContext, action: IEditBeer) {
  const { jCoreService, notificationService } = context;
  const { beverageId, outletId, thingId } = action.payload;
  const oldBeverageName = yield select(getBeverageName, beverageId);
  const newBeverage = yield select(getBeverage, beverageId);
  const content = yield select(getCurrentContent);
  const contentCommon = content ? content.managerAppCommon : null;

  try {
    yield call([jCoreService, jCoreService.editBeer], thingId, beverageId);
    yield put(setPressureChamberBeverage(outletId, thingId, newBeverage, oldBeverageName));

    const notificationText = (contentCommon.manager_app_notification_set_beverage_success || "")
      .replace("%OLDBEVERAGE%", oldBeverageName)
      .replace("%NEWBEVERAGE%", newBeverage.name);

    notificationService.addNotification({
      iconProps: { name: "ok" },
      text: (
        <Body>
          <ReactMarkdown source={notificationText} />
        </Body>
      )
    });
  } catch (error) {
    yield put(setPressureChamberBeverageError());

    const notificationText = contentCommon.manager_app_notification_set_beverage_error;
    notificationService.addNotification({
      iconProps: { name: "error" },
      text: (
        <Body>
          <ReactMarkdown source={notificationText} />
        </Body>
      )
    });
  }
}

export function* beersWatcher(context: IAppContext) {
  yield takeEvery(REQUEST_BEERS, requestBeers, context.jCoreService);
  yield takeEvery(EDIT_BEER, editBeer, context);
}

export default beersWatcher;
